import { render, staticRenderFns } from "./PayGoods.vue?vue&type=template&id=0a1ab7cc&scoped=true"
import script from "./PayGoods.vue?vue&type=script&lang=js"
export * from "./PayGoods.vue?vue&type=script&lang=js"
import style0 from "./PayGoods.vue?vue&type=style&index=0&id=0a1ab7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1ab7cc",
  null
  
)

export default component.exports